// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import NoSSR from '@/utils/no-ssr'
import { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Time from '@/utils/time';
import useMobileView from '@/hooks/useMobileView';
import PageContext from '@/utils/page-context';
import NewJobRating from '@/components/customer-zone/job/rating/new-job-rating';
import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import JobRatingThankYou from '@/components/customer-zone/job/rating/thank-you';
import JobRatingLinkUsed from '@/components/customer-zone/job/rating/link-used';
import CompanyService from '@/services/company-service';
import FeedbackService from '@/services/feedback-service';
import LeadMessage from '@/components/customer-zone/general/lead-message';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function JobFeedback() {

    const router = useRouter();
    const { t, c, i, r: rating, cc: contactID } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const { data: tenantData } = useQuery(
        ['czTenant', t],
        () => Fetch.preLogin({ tenantID: t }),
        { enabled: !!t }
    );
    const tenant = tenantData?.HttpStatusCode === 200 && tenantData.Results?.length > 0 ? tenantData.Results[0] : null;

    const { data: jobData } = useQuery(
        ['czFeedbackJob', t, c, i],
        () => Fetch.get({ url: `/CustomerZone/GetJob`, params: { jobCardID: i }, tenantID: t, customerID: c, apiUrlOverride: tenant.API }),
        { enabled: !!tenant }
    );

    const { data: companyData } = useQuery(
        ['czCompany', t, c],
        () => CompanyService.getCustomerZoneCompany(t, c, tenant.API),
        { enabled: !!tenant }
    );

    const [job, setJob] = useState<any>(null);
    const [company, setCompany] = useState<any>(null);

    const pageContext = useContext(PageContext);
    const [mobileView] = useMobileView();

    useEffect(() => {
        if (tenantData && !tenant) {
            router.replace(`/customerzone/joblist?t=${t}&c=${c}`);
        }
    }, [tenantData]);

    useEffect(() => {
        if (jobData && !job) {
            setJob(jobData);
            (pageContext as any).updateTenantName(jobData.headerTenantName);
        }
    }, [jobData]);

    useEffect(() => {
        if (companyData && !company) {
            setCompany(companyData);
        }
    }, [companyData]);

    const [showNewJobRating, setShowNewJobRating] = useState(false);
    const [showThankyou, setShowThankyou] = useState(false);
    const [showLinkUsed, setShowLinkUsed] = useState(false);

    const onRatingSubmission = async (ratingVal: any, comment: any) => {
        let now = await Time.nowCZ(t, c, tenant.API);
        let feedbackToSave = {
            ...feedback,
            Rating: ratingVal,
            Comment: comment,
            CompletedDate: Time.toISOString(now),
            CustomerContactID: contactID
        };
        await FeedbackService.saveFeedbackCustomerZone(feedbackToSave, t, c, tenant.API);
        setShowNewJobRating(false);
        setShowThankyou(true);
    };

    const [feedback, setFeedback] = useState<any>(null);

    const getFeedback = async () => {
        let result = await FeedbackService.getFeedbackByItemIDCustomerZone(job.ID, t, c, tenant.API);
        if (!result) {
            setShowLinkUsed(true);
        }
        setFeedback(result);
    };

    useEffect(() => {
        if (feedback) {
            if (feedback.Rating) {
                setShowLinkUsed(true);
            } else {
                setShowNewJobRating(true);
            }
        }
    }, [feedback]);

    useEffect(() => {
        if (job && tenant) getFeedback();
    }, [job, tenant]);

    if (!job || !tenant || !company) return null;

    return (
        <NoSSR>
            <LeadMessage customerID={c} tenantID={t} page={"customerzone/jobfeedback"} />

            {showNewJobRating ?
                <NewJobRating setShow={setShowNewJobRating} mobileView={mobileView} defaultRating={rating} jobCard={job} customerID={c} contactID={contactID}
                    company={company} onSubmit={onRatingSubmission}
                />
                : ''
            }

            {showThankyou ? <JobRatingThankYou mobileView={mobileView} company={company} /> : ''}

            {showLinkUsed ? <JobRatingLinkUsed mobileView={mobileView} company={company} jobCard={job} /> : ''}
        </NoSSR>
    );
}

export default JobFeedback;

export const Route = createFileRoute('/customerzone/jobfeedback')({ component: JobFeedback })
